import { loadingBallTagName } from '@ingka/loading-webc';
let loading;
let __inited = false;
export const generateLoadingBall = () => {
    if (!__inited) {
        loading = document.createElement(loadingBallTagName());
        loading.id = 'loader';
        loading.size = 'medium';
        loading.colour = 'secondary';
        __inited = true;
    }
    return loading.cloneNode(true);
};
